import React, { forwardRef } from "react";

const Input = forwardRef(
  ({
    type,
    placeholder,
    forr,
    label,
    eyeVisibility,
    props,
    inputRef,
    id,
    onChange,
    value,
    onBlur,
    onClick,
    defaultValue,
    name,
    accept,
    maxLength,
    onKeyPress,
    pattern,
    step,
    multiple,
    onFocus,
    disabled,
    max
  }) => {
    return (
      <div id="show_hide_password" className="form-floating">
        <input
          type={type}
          className="form-control"
          id={id}
          placeholder={placeholder}
          ref={inputRef}
          {...props}
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          defaultValue={defaultValue}
          name={name}
          accept={accept}
          maxLength={maxLength}
          pattern={pattern}
          onKeyPress={onKeyPress}
          step={step}
          onFocus={onFocus}
          multiple={multiple}
          disabled={disabled}
          max={max}
        />
        <label htmlFor={forr}>{label}</label>
        <div className="input-group-addon">
          <i className={eyeVisibility} aria-hidden="true" onClick={onClick}></i>
        </div>
      </div>
    );
  }
);

export default Input;
